import "@/App.css";
import "@/index.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth-context";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import About from "@/pages/About";
import Verify from "@/pages/Verify";
import VerifySearch from "@/pages/VerifySearch";
import ResetPassword from "@/pages/ResetPassword";
import TwoFactorChallenge from "@/pages/TwoFactorChallenge";
import ForgotPassword from "@/pages/ForgotPassword";
import PublicAlumniDirectory from "@/pages/PublicAlumniDirectory";
import { APP_ROUTES } from "@/app-routes";

function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center text-sm text-[var(--vs-text-secondary)]">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  // Force-reset password gate. Allow the reset page itself + auth endpoints through.
  if (user.must_reset_password && location.pathname !== "/reset-password") {
    return <Navigate to="/reset-password" replace />;
  }
  if (roles && !roles.includes(user.role)) return <Navigate to="/app" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/about" element={<About />} />
          <Route path="/2fa-challenge" element={<TwoFactorChallenge />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/verify" element={<VerifySearch />} />
          <Route path="/verify/:certNo" element={<Verify />} />
          <Route path="/alumni-directory" element={<PublicAlumniDirectory />} />

          <Route path="/reset-password" element={<ResetPassword />} />

          {/* All /app/* routes — declarative table from app-routes.jsx */}
          {APP_ROUTES.map(({ path, element, roles }) => (
            <Route
              key={path}
              path={path}
              element={<ProtectedRoute roles={roles}>{element}</ProtectedRoute>}
            />
          ))}

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
